module.exports = __webpack_public_path__ + "static/media/energy.4219dcba.svg";